import React, {PureComponent, Fragment} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import classNames from 'classnames';
import isNull from 'lodash/isNull';
import Alert from '@spothero/ui/alert';
import CheckoutUtils from 'checkout/checkout-utils';
import Price from 'common/price/Price';

class ReviewPurchase extends PureComponent {
    static propTypes = {
        user: PropTypes.object,
        isAirport: PropTypes.bool.isRequired,
        isMonthly: PropTypes.bool.isRequired,
        starts: PropTypes.string.isRequired,
        promoCode: PropTypes.object,
        creditApplied: PropTypes.oneOfType([
            PropTypes.bool,
            PropTypes.number
        ]),
        selectedRate: PropTypes.object
    };

    _renderPriceLabel = (defaultPrice, showServiceFees) => {
        const {
            isAirport,
            isMonthly,
            selectedRate,
            starts
        } = this.props;
        const {
            startDateFormatted,
            endDateFormatted
        } = (isMonthly)
            ? CheckoutUtils.getMonthlyReservationInfo(selectedRate, starts)
            : {
                startDateFormatted: null,
                endDateFormatted: null
            };
        const hasAirportSelectedRate = (isAirport && selectedRate && selectedRate.consumer_breakdown);
        const dailyPrice = (hasAirportSelectedRate) ? selectedRate.consumer_breakdown.price_per_day : null;
        const duration = (hasAirportSelectedRate) ? selectedRate.consumer_breakdown.days : null;
        const displayedPrice = (showServiceFees) ? (dailyPrice * duration) : defaultPrice;

        return (
            <div className="ReviewPurchase-line-item">
                <span className="ReviewPurchase-label">
                    {(isAirport)
                        ? (
                            <Fragment>
                                <Price amount={dailyPrice} /> x {duration} day{(duration > 1) ? 's' : ''}
                            </Fragment>
                        ) : (
                            (!isMonthly)
                                ? 'Subtotal'
                                : `${startDateFormatted} - ${endDateFormatted}`
                        )
                    }
                </span>
                <Price amount={displayedPrice} />
            </div>
        );
    }

    _renderServiceFees = serviceFees => {
        return (
            <div className="ReviewPurchase-line-item">
                Service Fees
                <Price amount={serviceFees} />
            </div>
        );
    }

    render() {
        const {
            user,
            isMonthly,
            isAirport,
            promoCode,
            creditApplied,
            selectedRate
        } = this.props;
        const amountToChargeClasses = classNames(
            'ReviewPurchase-line-item',
            'ReviewPurchase-amount-to-charge',
            {'ReviewPurchase-amount-to-charge-only': (!promoCode && !creditApplied)}
        );
        const {
            amountToCharge,
            creditUsed
        } = CheckoutUtils.getAmountToCharge({
            price: (selectedRate) ? selectedRate.price : 0,
            discount: (promoCode) ? promoCode.discountAmount * 100 : 0, // TODO bk - should come to us in pennies
            userCredit: user.credit
        });
        const showServiceFees = (
            isAirport
            && selectedRate
            && selectedRate.consumer_breakdown
            && !isNull(selectedRate.consumer_breakdown.taxes_and_fees)
        );

        return (
            <div className="ReviewPurchase">
                {(isMonthly && selectedRate && selectedRate.recurrable) &&
                    <Alert type="highlight">By clicking &quot;Pay &amp; Reserve&quot; you confirm that this credit card will be charged monthly until you cancel.</Alert>
                }
                {selectedRate &&
                    <div className="ReviewPurchase-breakdown">
                        {(promoCode || creditApplied) &&
                            <div>
                                {this._renderPriceLabel(selectedRate.price, showServiceFees)}
                                {showServiceFees && this._renderServiceFees(selectedRate.consumer_breakdown.taxes_and_fees)}
                                {promoCode && !isNaN(promoCode.discountAmount) &&
                                    <div className="ReviewPurchase-line-item ReviewPurchase-discount ReviewPurchase-discount-promo">
                                        <span className="ReviewPurchase-label">
                                            <span>
                                                {promoCode.codeType === 'credit' &&
                                                    <span>Promo Credit</span>
                                                }
                                                {promoCode.codeType !== 'credit' &&
                                                    <span>Promo Code</span>
                                                }
                                                {' '}Applied:
                                            </span>
                                        </span>
                                        <span>
                                            -<Price amount={promoCode.discountAmount * 100} />
                                            {((promoCode.codeType === 'credit' && creditUsed < 0) || (promoCode.codeType !== 'credit' && promoCode.discountAmount > selectedRate.price / 100)) &&
                                                <sup>*</sup>
                                            }
                                        </span>
                                    </div>
                                }
                                {(creditApplied && creditUsed > 0) &&
                                    <div className="ReviewPurchase-line-item ReviewPurchase-discount ReviewPurchase-discount-credit">
                                        <span className="ReviewPurchase-label">SpotHero Credit:</span>
                                        <span>-<Price amount={creditUsed} /></span>
                                    </div>
                                }
                            </div>
                        }
                        {(!promoCode && !creditApplied) &&
                            <Fragment>
                                {this._renderPriceLabel(amountToCharge, showServiceFees)}
                                {showServiceFees && this._renderServiceFees(selectedRate.consumer_breakdown.taxes_and_fees)}
                            </Fragment>
                        }
                        <h3 className={amountToChargeClasses}>
                            <span className="ReviewPurchase-label">
                                Total:
                            </span>
                            {' '}<Price amount={amountToCharge} />
                        </h3>
                    </div>
                }
            </div>
        );
    }
}

const mapStateToProps = state => {
    const {
        checkout: {
            creditApplied,
            promoCode
        },
        searchRequest: {
            monthly: isMonthly,
            airport: isAirport,
            starts
        },
        spot: {
            selected: {
                selectedRate
            }
        },
        user
    } = state;

    return {
        user: user.data,
        selectedRate,
        isAirport,
        isMonthly,
        starts,
        promoCode,
        creditApplied
    };
};

export default connect(mapStateToProps)(ReviewPurchase);
